import { ContentEditable, ContentEditableProps } from '@lexical/react/LexicalContentEditable';
import { cn } from '@talentmesh/ui/lib/utils';

export type RichContentEditableProps = ContentEditableProps;

const RichContentEditable = ({ className, ...props }: RichContentEditableProps) => {
    return (
        <ContentEditable
            data-cy="RTEContentEditable"
            {...props}
            className={cn(
                'rte-content',
                'border-border bg-background border outline-none',
                'min-h-60 overflow-y-auto px-3 py-3',
                'text-foreground text-sm leading-relaxed [&>h4]:text-xl [&>h4]:font-semibold [&>p]:text-sm',
                'rounded-b-xl',
                'focus:ring-ring/30 focus:border-primary focus:ring-2',
                'transition-colors duration-150',
                className,
            )}
        />
    );
};

export default RichContentEditable;
